"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestCacheControl = exports.IkeRestCacheBasic = exports.IkeRestCacheFactory = void 0;
exports.IkeRestCacheFactory = {
    create(obj) {
        return new IkeRestCacheBasic(obj);
    },
};
class IkeRestCacheBasic {
    constructor(obj) {
        this.obj = obj;
        this.cache = {};
    }
    getKey(key, value) {
        if (this.obj.canCache(key)) {
            return `${key}:${value}`;
        }
        throw new Error(`Invalid cacheKey ${this.obj.actionName}:${key}`);
    }
    get(key, value) {
        const internalKey = this.getKey(key, value);
        return this.cache[internalKey];
    }
    set(key, value, obj) {
        const internalKey = this.getKey(key, value);
        this.cache[internalKey] = obj;
    }
    has(key, value) {
        const internalKey = this.getKey(key, value);
        return this.cache[internalKey] != null;
    }
}
exports.IkeRestCacheBasic = IkeRestCacheBasic;
class IkeRestCacheControl {
    constructor() {
        this._caches = {};
    }
    get(obj, key) {
        if (this._caches[obj.actionName] == null) {
            this._caches[obj.actionName] = exports.IkeRestCacheFactory.create(obj);
        }
        const cache = this._caches[obj.actionName];
        if (!obj.canCache(key)) {
            throw new Error(`Cannot get one on non cached key: ${obj.actionName}.${key}`);
        }
        return cache;
    }
    clear(obj) {
        if (obj != null) {
            this._caches[obj.actionName] = null;
        }
        else {
            this._caches = {};
        }
    }
}
exports.IkeRestCacheControl = IkeRestCacheControl;
//# sourceMappingURL=cache.js.map